Namespace('Customer.Views.Reports')

class Customer.Views.Reports.OperatorAvailabilityView extends Backbone.View
  template: JST['backbone/templates/customer/reports/operator_availability/operator_availability']
  className: 'operator-availability'

  initialize: ({pendingTicketsIncluded})->
    @teamID = ''
    @report = new Customer.Reports.OperatorAvailabilityReport()
    @navbarView = new Customer.Views.Reports.OperatorAvailabilityNavbarView
      report: @report
    @teamSelectView = new Customer.Views.Reports.OperatorAvailabilityTeamSelectView()
    @teamSelectView.fetchTeams()
    @tableView = new Customer.Views.Reports.OperatorAvailabilityTableView
      reportItems: @report.operators()
      pendingTicketsIncluded: pendingTicketsIncluded
    @metricsContainerView = new Customer.Views.Reports.OperatorAvailabilityMetricsContainerView
      metrics: @report.metrics()
    @listenTo(@navbarView, 'refresh', @fetchReport)
    @listenTo(@navbarView, 'refresh:time:update', @updateAutomaticRefresh)
    @listenTo(@teamSelectView, 'change', ({teamID}) =>
      @teamID = teamID
      @fetchReport()
    )

  render: =>
    @$el.html(@template())
    @$el.find('.operator-availability-navbar-container').html(@navbarView.render().el)
    @$el.find('#operator-availability-team-select').html(@teamSelectView.render().el)
    @$el.find('#operator-availability-metrics-container').html(@metricsContainerView.render().el)
    @$el.find('.operator-availability-table-container').html(@tableView.render().el)

    @refreshHandler = Visibility.every(@defaultRefreshTime(), () => @fetchReport(false))
    Visibility.change(@onVisiblilityChange)
    @

  onVisiblilityChange: (event, state) =>
    @fetchReport() if state == 'visible'

  updateAutomaticRefresh: (refreshTime) =>
    Visibility.stop(@refreshHandler)
    @refreshHandler = Visibility.every(refreshTime.get('value'), () => @fetchReport(false))

  fetchReport: (showPlaceholder = true) =>
    @displayPlaceholder() if showPlaceholder
    @report.fetch
      data: if @teamID then {users_group_id: @teamID}
      reset: true
      success: @updateTableContent
      error: -> showError(I18n.t('generic_error_message'))

  displayPlaceholder: =>
    @navbarView.displayPlaceholderContent()
    @tableView.displayPlaceholderContent()
    @metricsContainerView.displayPlaceholderContent()

  updateTableContent: =>
    @navbarView.enableComponents()
    @tableView.renderTableBody()
    @tableView.displayLoadedContent()
    @metricsContainerView.render()
    @metricsContainerView.displayLoadedContent()

  defaultRefreshTime: =>
    @navbarView.selectedRefreshTime().get('value')
